"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf3 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _emotion = require("emotion");

var _memoizeOne = _interopRequireDefault(require("memoize-one"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _Pagination = _interopRequireDefault(require("../Pagination"));

var _Select = _interopRequireDefault(require("../Select"));

var _TextField = _interopRequireDefault(require("../TextField"));

var TablePagination =
/*#__PURE__*/
function (_PureComponent) {
  (0, _inherits2["default"])(TablePagination, _PureComponent);

  function TablePagination() {
    var _getPrototypeOf2;

    var _this;

    (0, _classCallCheck2["default"])(this, TablePagination);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = (0, _possibleConstructorReturn2["default"])(this, (_getPrototypeOf2 = (0, _getPrototypeOf3["default"])(TablePagination)).call.apply(_getPrototypeOf2, [this].concat(args)));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "state", {
      goToPage: ''
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onPageChange", function (_ref) {
      var selected = _ref.selected;

      _this.props.onPageChange(selected);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onPageSizeChange", function (e) {
      e && _this.props.onPageSizeChange(e.value);
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onGoToPageChange", function (e) {
      _this.setState({
        goToPage: e.target.value
      });
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "onGoToPageSubmit", function (e) {
      if (e.key === 'Enter') {
        var parsedPage = parseInt(_this.state.goToPage, 10);

        if (!Number.isNaN(parsedPage)) {
          _this.props.onPageChange(parsedPage - 1);
        }
      }
    });
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getPageSizeOptions", (0, _memoizeOne["default"])(function (pageSizeOptions) {
      return pageSizeOptions.map(function (pageSize) {
        return {
          label: pageSize,
          value: pageSize
        };
      });
    }));
    (0, _defineProperty2["default"])((0, _assertThisInitialized2["default"])(_this), "getSelectedPageSizeOption", function () {
      return {
        label: _this.props.pageSize,
        value: _this.props.pageSize
      };
    });
    return _this;
  }

  (0, _createClass2["default"])(TablePagination, [{
    key: "render",
    value: function render() {
      var _this$props = this.props,
          className = _this$props.className,
          page = _this$props.page,
          pages = _this$props.pages,
          pageSizeOptions = _this$props.pageSizeOptions,
          showPageJump = _this$props.showPageJump,
          showPageSizeOptions = _this$props.showPageSizeOptions,
          goToLabelText = _this$props.goToLabelText,
          perPageLabelText = _this$props.perPageLabelText;
      var goToPage = this.state.goToPage;

      if (pages < 1) {
        return null;
      }

      var pageSizeSelect = showPageSizeOptions ? _react["default"].createElement(_Select["default"], {
        clearable: false,
        label: perPageLabelText,
        options: this.getPageSizeOptions(pageSizeOptions),
        value: this.getSelectedPageSizeOption(),
        onChange: this.onPageSizeChange
      }) : null;
      var pageJumpField = showPageJump ? _react["default"].createElement(_TextField["default"], {
        label: goToLabelText,
        value: goToPage,
        onChange: this.onGoToPageChange,
        onKeyDown: this.onGoToPageSubmit
      }) : null;
      return _react["default"].createElement("div", {
        className: (0, _emotion.cx)(className, 'rt-pagination')
      }, pageSizeSelect, pages > 1 && pageJumpField, pages > 1 && _react["default"].createElement(_Pagination["default"], {
        initialPage: page,
        forcePage: page,
        pageCount: pages,
        onPageChange: this.onPageChange
      }));
    }
  }]);
  return TablePagination;
}(_react.PureComponent);

exports["default"] = TablePagination;
TablePagination.propTypes = {
  className: _propTypes["default"].string,
  page: _propTypes["default"].number.isRequired,
  pages: _propTypes["default"].number.isRequired,
  pageSize: _propTypes["default"].number.isRequired,
  pageSizeOptions: _propTypes["default"].arrayOf(_propTypes["default"].number).isRequired,
  showPageJump: _propTypes["default"].bool,
  showPageSizeOptions: _propTypes["default"].bool,
  onPageChange: _propTypes["default"].func.isRequired,
  onPageSizeChange: _propTypes["default"].func.isRequired,
  perPageLabelText: _propTypes["default"].string,
  goToLabelText: _propTypes["default"].string
};
TablePagination.defaultProps = {
  perPageLabelText: 'Per Page',
  goToLabelText: 'Go To'
};